// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b54f4f6f","865":"d247a40f"}[chunkId] + ".chunk.js";
};